import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

const Loading = () => {
    return (
        <Flex justifyContent='center' p={4}>
            <Spinner color="#00838A" size='lg' />
        </Flex>
    );
};

export default Loading;
